/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_No_ClientsInputs */

const cs_demands_no_clients = /** @type {(inputs: Demands_No_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádní klienti.`)
};

const en_demands_no_clients = /** @type {(inputs: Demands_No_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No clients found.`)
};

/**
* | output |
* | --- |
* | "No clients found." |
*
* @param {Demands_No_ClientsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_no_clients = /** @type {((inputs?: Demands_No_ClientsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_No_ClientsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_no_clients(inputs)
	return cs_demands_no_clients(inputs)
});